<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0010_device_embedded_information_detail</div>
        <app-header>esma</app-header>
        <div :class="'container ' + pageContainerSize">
          <title-and-slot title="機器・組込情報" >

          </title-and-slot>

          <div class="row" style="margin-bottom:10px;">
            <div class="col-xs-4">
              <button class="btn btn-primary" style="width: 25%;float: left;margin-left: -10px;min-width:100px;" @click="backToList" >＜　戻る</button>
            </div>
            <div class="col-xs-8">
              <div v-if="is_new == false" style="width:180px;float:right;font-size:12px;text-align: right;">機器登録番号：{{deviceControlNumber}}</div>
              <div v-if="is_new == false" style="width:180px;float:right;font-size:12px;text-align: right;">登録日：{{registrationDate}}</div>
            </div>
            <div class="col-xs-12">
              <div style="float:right;font-size:12px;text-align: right;color:red;">＊入力必須項目</div> 
            </div>
          </div>
          <div class="row" style="margin-bottom:10px;">
            承認状態：
            <input :disabled="true" style=" border: solid #337ab7 1px;width: 90px; padding-left:4px;margin: 2px;border-radius: 5px;background-color: #e2ecf5;font-size: 12px;" :value="approvalStatus" />
            状態:
            <select 
            :disabled="readOnly"
            :value="Status"
            @change="Status =$event.target.value"
            :style="statusFieldStyle"
             >
            <option v-for="option in StatusOptions" :selected="option==Status" :key="option" :value="option">{{option}}</option>
            </select>
            申請No：
            <input type="button" 
                  style="border: solid #337ab7 1px;width: 140px; padding-left:4px;margin: 2px;margin-bottom: -6px;border-radius: 5px;background-color: #e2ecf5;font-size: 12px;color: #008cff;text-decoration: underline;" 
                :value="approvalHistoryTorokuNumber"
                @click="onConfirmExecuteProcessConfirmation"
                  />
                <span
                v-if="showApprovalHistoryBulkTorokuNumberQty"
                style="color:red;" >※この申請は一括申請です。同一の申請が {{approvalHistoryBulkTorokuNumberQty}} 件あります。</span>
          </div>

          <div class="row" style="margin-bottom:10px;">
            <div class="col-xs-4" style="">
              <!-- Coll A<br> -->
              <field-box   v-for="f in formFields.col1"  v-bind:key="f.id" v-bind:data="f" :read="readOnly" :val="values[f.id]"></field-box>
            </div>
            <div class="col-xs-8" style="">
              <div class="row">
                <div class="col-xs-6" style="">
                  <!-- Coll B <br> -->
                  <field-box   v-for="f in formFields.col2"  v-bind:key="f.id" v-bind:data="f" :read="readOnly"   :val="values[f.id]"></field-box>
                </div>
                <div class="col-xs-6" style="">
                  <!-- Coll C<br> -->
                  <field-box   v-for="f in formFields.col3"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly"  :val="values[f.id]"></field-box>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12" style="">
                  <field-box   v-for="f in formFields.col2b"  v-bind:key="f.id" v-bind:data="f" :read="readOnly"   :val="values[f.id]" :option="{rows:2}"></field-box>
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="margin-bottom:20px;">
            <button v-if="approvalcancelmode == true" :disabled="false" class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: -10px;background: #A6A6A6;" @click="approvalCancelbtn" >ｷｬﾝｾﾙ</button>
              <button
                v-if="approvalcancelmode == true"
                class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: 10px;background: #FF7C80;;background: #337ab7;" @click="onapprovalSaveDevEmbedded" >入力完了</button>
               <span v-show="approvalcancelmode == true">
                 <span style='float: right;
                         font-size: 15px;
                         margin-right: 70px;
                         font-weight: 800;
                         margin-top:-35px;
                         letter-spacing: 3px;
                         color:red;'
                    >※差戻通知を入力し、入力完了をクリックして下さい。(任意)
                 </span>
               </span>
              <button
                v-show="draftWriteMode == false"
                v-if="read_only == false"
                :disabled="checkUserPermission(true,permissionMode.EDIT) == false"
                class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: 10px;background: #337ab7;" @click="onLocalUpSaveDevEmbedded" >上書保存</button>
              <button
                v-show="draftWriteMode == true"
                v-if="read_only == false"
                :disabled="checkUserPermission(true,permissionMode.EDIT) == false"
                class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: 10px;background: #337ab7;" @click="onLocalSaveDevEmbedded" >下書保存</button>
              <button v-if="read_only == false" :disabled="false" class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: 10px;background: #A6A6A6;" @click="btnCancel" >ｷｬﾝｾﾙ</button>
              <button 
                v-else
                v-show="hideEditMainBtn == false && approvalcancelmode == false"
                :disabled="(disableEditMainBtn || checkUserPermission(true,permissionMode.EDIT) == false) || approvalcancelmode == true"
                 class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: 10px;" @click="onEdit" >編集</button>
          </div>
          <span v-show="is_new == true">「下書保存」ボタンを押したら「組込情報」が出ます。</span>
              <div class="row" style="margin-bottom:10px;" >
                <transition name="fade" >
                  <div>
                    <div :style="subTableDeviceEmbeddedInformationStyle">
            　      <h3>組込情報</h3>
                    <sub-table_device-embedded-information
                      :disable_new_btn = "disableNewToSubTableBtn"
                      :disable_edit_btn = "disableEditSubTableBtn"
                      :hide_new_btn = "hideNewToSubTableBtn"
                      :hide_edit_btn = "hideEditSubTableBtn"
                      style="margin-bottom:20px"
                      :ref_id="deviceControlNumber"
                      :fk_id="deviceSeqId"
                      @data-saved="subTableSaved"
                      @updatedtotalnumber="device_totalNumber = $event"
                      tag_reload="reloadSubTableDeviceEmbeddedInformation" />
                    </div>
                  </div>
                </transition>
              </div>
          <div class="row" style="margin-bottom:20px;">
              <button
              :disabled="checkUserPermission(true,permissionMode.BROWSE) == false"
                v-if="is_new == false && approvalcancelmode == false"
                class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: -10px;background: #A6A6A6;border-color:#A6A6A6;"
                @click="showHistory"
                >更新履歴</button>
              <button
              v-show ="hideApplyConfirmationBtn == false && approvalcancelmode == false"  @click="processApprovalApprove()"
              :disabled="checkUserPermission(true,permissionMode.EDIT) == false"
              class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: 10px;background: #92D050;border-color:#92D050;">確認</button>

              <button
              v-show ="this.refreshSequencer > 0  && hideApplyRejectBtn == false && hideApplyConfirmationBtn == true && approvalcancelmode == false"   @click="onapprovalSaveDevEmbeddedReason"
              :disabled="checkUserPermission(true,permissionMode.EDIT) == false"
              class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: 10px;background: #FF7C80;border-color:#FF7C80;">取戻</button>

              <button
              v-show ="hideApplyConfirmationBtn == false && approvalcancelmode == false"  @click="processApprovalCancel"
              :disabled="checkUserPermission(true,permissionMode.EDIT) == false"
              class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: 10px;background: #FF7C80;border-color:#FF7C80;">差戻</button>

              <button
                v-show ="hideApplicationBtn == false && approvalcancelmode == false"
                :disabled="disableApplicationBtn || checkUserPermission(true,permissionMode.EDIT) == false"
                class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: 10px;background: #92D050;border-color:#92D050;"
                @click="onConfirmExecuteProcess" >申請</button>

              <button v-show ="hideCopyMainBtn == false && approvalcancelmode == false"
                  :disabled="checkUserPermission(true,permissionMode.EDIT) == false"
                  class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-right: 10px;" @click="cloneRecord" >コピー</button>
                  <!--<button v-if="read_only == true"
                  :disabled="checkUserPermission(true,permissionMode.DELETE) == false
                  class="btn btn-primary" style="min-width:100px;float:right;margin-left: 10px;background: #FF7C80;border-color:#FF7C80;" @click="onDelete">削除</button>
                  -->
          </div>
        </div>
        <device-embedded-information-confirmation-modal tag="showBulkImportConfimationModal" />
        <confirmation-modal tag="confirmDeviceEmbeddedInformationAddcancel" @done="processApprovalCancelBack" />
        <confirmation-modal tag="confirmDeviceEmbeddedInformationAddcancelReason" @done="processApprovalCancelBackReason" />
        <confirmation-modal tag="confirmDeviceEmbeddedInformationAddCheck" @done="onDeviceEmbeddedInformationAddCheckConfirm" />
        <confirmation-modal tag="confirmDeviceEmbeddedInformationUpAddCheck" @done="onDeviceEmbeddedInformationUpAddCheckConfirm" />
        <confirmation-modal tag="notificationAfterSave" @done="afterTheNotificationAfterSave" />
        <confirmation-modal tag="notificationAfterdeviceInformationApprovalStartedRequest" @done="afterTheNotificationAftercancel" />
        <application-confirmation-modal tag="deviceEmbeddedApplicationConfimationModal" />
        <!-- <log-history tag="showDeviceEmbeddedInformationlogHistoryModal"/>] -->
        <change-history tag="showDeviceEmbeddedInformationlogHistoryModal" id_label="機器管理番号" />
        <confirmation-modal tag="showConfimationModalSetdevice" @done="confirmedSetdevice"></confirmation-modal>
        <device-modal tag="showdeviceModal" @selected="ondeviceModalSelected"></device-modal>
        <!-- <application-confirmation-modal-confirmation tag="deviceEmbeddedApplicationConfimationModalConfirmation" /> -->
        <confirmation-modal tag="deletedeviceEmbeddedInformationDetailModal" @done="onConfirmDelete" />
    </div>
</template>

<script>
import deviceembeddedinformationaddcheck from '@/components/modals/device-embedded-information-add_check';
import subTableDeviceEmbeddedInformation from '@/components/sub_pages/device-embedded-detail';
import Vue from 'vue';
import moment from 'moment';
import { fields, filed_types } from '@/rules/fields_device_embedded_information';
import bulkImportConfirmationModal from "@/components/modals/device-embedded-information-confirmation-modal";
import applicationConfirmationModal from '@/components/modals/application-confirmation-modal';
// import applicationConfirmationModalConfirmation from '@/components/modals/application-confirmation-modal-confirmation';
import { utils } from '@/libs/utils';
import _debug from 'debug';
var mdebug = _debug('esma:device_embedded_information');
import fieldBoxes from '@/components/form-field';
// import logHistoryModal from '@/components/modals/log-history-modal';
import changeHistoryModal from "@/components/modals/change-history-modal";
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import constants from "@/rules/constants";
import deviceModal from "@/components/modals/device-modal";
Vue.component("device-modal", deviceModal);

import { bus } from '@/libs/bus';
export default {
  mixins: [mixinPageCommon,mixinDatasource],
  components: {
    'field-box': fieldBoxes,
    'sub-table_device-embedded-information': subTableDeviceEmbeddedInformation,
    "device-embedded-information-confirmation-modal" :bulkImportConfirmationModal,
    'device-embedded-information-bach-edit-modal' : deviceembeddedinformationaddcheck,
    // 'application-confirmation-modal-confirmation':applicationConfirmationModalConfirmation,
    'application-confirmation-modal':applicationConfirmationModal,
    // 'log-history':logHistoryModal
    "change-history": changeHistoryModal,
  },
  data() {
    return {
      api_name:"device_embedded_information",
      page_acl: acl.device_embedded_information_detail,
      approval_history_id:"",
      approval_id:null,
      approvalcancel_mode:false,
      hide_approval_cancel_field:true,
      local_status:false,
      save_edit_cliqued:false,
      temp_device_management_number:"",
      local_seq_id:-1,
      device_totalNumber : 0,
      approval_history_toroku_number:false,
      company_selection_started:false,
      approval_id:null,
      approval_history_bulk_toroku_number_qty:0,
      show_approval_history_bulk_toroku_number_qty:false,
      refresh_sequencer:1
    };
  },
  computed: {
    refreshSequencer:{
      get(){
        return this.refresh_sequencer;
      },
      set(v){
        this.refresh_sequencer = v;
      }
    },
    statusFieldStyle(){
      if(this.$store.state["current_field_style"] && this.$store.state["current_field_style"]["status"]){
        return  "border: solid #337ab7 1px;width: 90px; padding-left:4px;margin: 2px;border-radius: 5px;background-color: #e2ecf5;font-size: 12px;" +this.$store.state["current_field_style"]["status"];
      }else{
        return "border: solid #337ab7 1px;width: 90px; padding-left:4px;margin: 2px;border-radius: 5px;background-color: #e2ecf5;font-size: 12px;"
      }
    },
    showApprovalHistoryBulkTorokuNumberQty(){
      return this.approvalHistoryBulkTorokuNumberQty > 0 && this.loadBy == 'fk_id';
    },
    approvalHistoryBulkTorokuNumberQty:{
      get(){
        return this.approval_history_bulk_toroku_number_qty;
      },
      set(v){
        this.approval_history_bulk_toroku_number_qty = v;
      }
    },
    approvalcancelmode:{
      get(){
        return this.approvalcancel_mode;
      },
      set(v){
        this.approvalcancel_mode = v;
      }
    },
    localSeqId:{
      get(){
        return this.local_seq_id;
      },
      set(v){
        this.local_seq_id = v;
      }
    },
    // About to hide or show the buttons start
    disableEditMainBtn(){ //編集 (edit main)
      if(this.loadBy == 'fk_id' ){
        return this.hideForApplicant  && this.approvalStatus == "申請中"
      }
      return this.approvalStatus == "申請中"
    },
    disableNewToSubTableBtn(){// 新規 (new to sub-table)
      if(this.loadBy == 'fk_id' ){
        return this.hideForApplicant 
      }
      return this.approvalStatus == "申請中"
    },
    disableEditSubTableBtn(){//編集 (edit subtable)
      if(this.loadBy == 'fk_id' ){
        return this.hideForApplicant 
      }
      return this.approvalStatus == "申請中"
    },
    disableCopyMainBtn(){ //コピー
      return false; // There is no condition to hide Copy
    },
    disableApplicationBtn(){ //申請/Application
      return (this.approvalStatus != "下書中") || (this.$store.state[this.stateCurrentRow]["device_control_number"]=="" && this.device_totalNumber == 0);
    },
    draftWriteMode(){
      return this.loadBy != "fk_id";
    },
    hideForApplicant(){
    if(this.loadBy != 'fk_id' ){
        return false
      }
      if(typeof this.$store.state[this.stateCurrentRow]["approval_history_next_approver"] == "undefined" && this.isAdmin == true)
      {
        return false;
      }
      else
      {//                                               user is the applicant                                     and            user is not the next approver the  hide
        return this.$store.state[this.stateCurrentRow]["approval_history_applicant"] == Vue.localStorage.get("userID") && this.$store.state[this.stateCurrentRow]["approval_history_next_approver"] != Vue.localStorage.get("userID");
      }
    },
    hideApprovalcancel(){
      this.hide_approval_cancel_field = ((this.retractionReason == ""));
      this.hideApprovalCancelSet(this.hide_approval_cancel_field);
      if( this.loadBy != "fk_id" || this.approvalStatus != "申請中" ){
        return true;
      }else{
        return false
      }
    },
    hideEditMainBtn(){// 編集 (edit main)
      return this.hideForApplicant &&  this.approvalStatus == "申請中"
    },
    hideNewToSubTableBtn(){// 新規 (new to sub-table)
      return this.hideForApplicant
    },
    hideEditSubTableBtn(){//編集 (edit subtable)
      return this.hideForApplicant
    },
    hideApprovalcancelBtn(){// 差戻
      return this.hideApprovalcancel
    },
    hideCopyMainBtn(){ //コピー
      return this.loadBy == 'fk_id' || this.is_new == true;
    },
    hideApplicationBtn(){ //申請/Application
      return (this.loadBy == "fk_id" && this.approvalStatus != "下書中") || this.approvalStatus != "下書中";
    },
    hideApplyConfirmationBtn(){ //確認/Confirmation
      if(this.loadBy != 'fk_id'){
        return true
      }
      return this.hideForApplicant || this.approvalStatus != "申請中";
    },
    hideApplyRejectBtn(){ //差戻/Reject
      //this.loadBy == 'fk_id'
      return this.refreshSequencer > 0 && this.hideApprovalcancel;
    },
    // About to hide or show the buttons end
    Virtual_environment:{
      get(){
        if(this.local_status === false){
          return this.$store.state[this.stateCurrentEditing]["virtual_environment"] || "";
        }else{
          return this.local_status;
        }
       },
      set(v){
       this.$store.state[this.stateCurrentRow]["virtual_environment"] = this.local_status = v;
       this.$store.state[this.stateCurrentEditing]["virtual_environment"] = this.local_status = v;
       }
    },
    Leasing_or_rental:{ // FIXME: This fields are not goog, it is used as copy and paster, but there are a log or unecessary code
      get(){
        if(this.local_status === false){
          return this.$store.state[this.stateCurrentEditing]["leasing_or_rental"] || "";
        }else{
          return this.local_status;
        }
       },
      set(v){
       this.$store.state[this.stateCurrentRow]["leasing_or_rental"] = this.local_status = v;
       this.$store.state[this.stateCurrentEditing]["leasing_or_rental"] = this.local_status = v;
       }
    },
    Equipment_Classification:{
      get(){
        if(this.local_status === false){
          return this.$store.state[this.stateCurrentEditing]["equipment_classification"] || "";
        }else{
          return this.local_status;
        }
       },
      set(v){
       this.$store.state[this.stateCurrentRow]["equipment_classification"] = this.local_status = v;
       this.$store.state[this.stateCurrentEditing]["equipment_classification"] = this.local_status = v;
       }
    },
    Cpu_Count:{
      get(){
        if(this.local_status === false){
          return this.$store.state[this.stateCurrentEditing]["cpu_count"] || "";
        }else{
          return this.local_status;
        }
       },
      set(v){
       this.$store.state[this.stateCurrentRow]["cpu_count"] = this.local_status = v;
       this.$store.state[this.stateCurrentEditing]["cpu_count"] = this.local_status = v;
       }
    },
    Status:{
      get(){
        if(this.local_status === false){
          return this.$store.state[this.stateCurrentRow]["status"] || "";
        }else{
          return this.local_status;
        }
      },
      set(v){
        this.$store.state[this.stateCurrentEditing]["status"] = this.local_status = v;
        this.$store.state[this.stateCurrentEditing]["status"] = this.local_status = v;
      }
    },
    StatusOptions(){
      var temp = fields.status.options;
      if(this.is_new == true){
        temp = fields.status.options_for_new
      }
      return temp;
    },

    subTableDeviceEmbeddedInformationStyle(){
      if(this.saveEditClicked || this.is_new == false){
        return "";
      }else{
        return "opacity: 0.5;";
      }
    },
    saveEditClicked:{
      get(){
        return this.save_edit_cliqued;
      },
      set(v){
        this.save_edit_cliqued = v;
      }
    },
    approvalHistoryId:{
      get(){
        return this.approval_history_id;
      },
      set(v){
        this.approval_history_id = v;
      }
    },
    approvalHistoryTorokuNumber:{
      get(){
        return this.approval_history_toroku_number;
      },
      set(v){
        this.approval_history_toroku_number = v;
      }
    },
    isAdminSavingApplication (){
      return this.isAdmin && this.loadBy == 'fk_id';
    },
    showFieldchangedStyle (){
      return (this.$store.state[this.stateCurrentRow]["approval_status"] == "申請中" || this.$store.state[this.stateCurrentRow]["approval_status"] == "差戻") && (this.isAdmin || this.$store.state[this.stateCurrentRow]["approval_history_next_approver"])
    },
    showapprovalStatus (){
      return (this.$store.state[this.stateCurrentRow]["approval_status"] == "承認済")
    },

    approvalId:{
      get(){
        return this.approval_id;
      },
      set(v){
        this.approval_id = v;
      }
    },
    approvalStatus(){
      return this.$store.state[this.stateCurrentEditing]["approval_status"] || this.$store.state[this.stateCurrentRow]["approval_status"]
    },
    retractionReason(){
      if(this.$store.state[this.stateCurrentRow]["retraction_reason"] != null){
        return this.$store.state[this.stateCurrentRow]["retraction_reason"];
      }else{
        return ""
      }
    },
    //ApplicationStatus(){
    //  return this.$store.state[this.stateCurrentEditing]["status"] || this.$store.state[this.stateCurrentRow]["status"]
    //},
    deviceControlNumber(){
      return this.$store.state[this.stateCurrentRow]["device_control_number"]
    },
    deviceSeqId(){
      return parseInt(this.$store.state[this.stateCurrentRow]["seq_id"]||this.localSeqId);
    },
    registrationDate(){
      return  utils.format_date(this.$store.state[this.stateCurrentRow]["registration_date"]);
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    //allowEditDeviceControlNumber(){
    //  return this.localSeqId != Number.MAX_SAFE_INTEGER && this.deviceControlNumber != "" && typeof  this.deviceControlNumber != "undefined";
    //},
    formFields() {
      return {
        col1:[
          utils.extend(fields.device_control_number, {disabled: true , read_only:true}),
          utils.extend(fields.virtual_environment, {
            on_set_value:(data) =>{
              setTimeout(() => {
                bus.$emit("virtual_base_unit",{val: data == "有"})
              }, 100);
            }
          }),
          utils.extend(fields.virtual_base_unit, {
            disabled: false,
            required: true,
            force_readonly: true,
            field_style: " width: 100%;display: block;" ,
            buttons: [
              {
                  btn_style:"width:100%;margin-left:2px;padding-left: 1px;padding-right: 1px;float:right; margin-top: 2px;margin-bottom: 10px;background: #43c9de;border-color:#43c9de;",
                  type:"callback",
                  callback:(b)=>{
                    this.devicePopUp()
                  },
                  label:"機器"// Need the spec.
              }
          ],
            listen_for: [
              {
                name: "virtual_base_unit",
                mode: "disable_and_clean_if_value",
                disable_if_value: true
              }
            ],
          }),
          utils.extend(fields.company, {}),
          utils.extend(fields.equipment_in_charge_department, {}),
          utils.extend(fields.equipment_in_charge_team, {}),
          utils.extend(fields.equipment_in_charge_classification, {
             on_set_value:(data) =>{

              setTimeout(() => {

                if(data == "IT所管システム"){
                  bus.$emit("upd_license_jurisdiction_system_it",{val: true})
                  bus.$emit("upd_license_jurisdiction_system",{val: false})
                }else if(data == "EUC・その他"){
                  bus.$emit("upd_license_jurisdiction_system",{val: true})
                  bus.$emit("upd_license_jurisdiction_system_it",{val: false})
                }else{
                  // bus.$emit("upd_license_jurisdiction_system_it",{val: false})
                  // bus.$emit("upd_license_jurisdiction_system",{val: false})
                }
              }, 300);
            }
          }),
          utils.extend(fields.equipment_in_charge_system_it, {
            disabled: false,
            required: true,
            field_style: " width: 100%;display: block;" ,
            listen_for: [
              {
                name: "upd_license_jurisdiction_system_it",
                mode: "disable_and_clean_if_value",
                disable_if_value: true
              }
            ],
          }),
          utils.extend(fields.equipment_in_charge_system, {
            disabled: false,
            required: true,
            field_style: " width: 100%;display: block;" ,
            listen_for: [
              {
                name: "upd_license_jurisdiction_system",
                mode: "disable_and_clean_if_value",
                disable_if_value: true
              }
            ],
          }),
        ],
        col2:[
          utils.extend(fields.computer_name, {}),
          utils.extend(fields.leasing_or_rental, {}),
          utils.extend(fields.manufacture_name, {}),
          utils.extend(fields.model_name, {}),
          utils.extend(fields.equipment_classification, {}),
          utils.extend(fields.cpu_count, {})
        ],
        col3:[
          utils.extend(fields.installation_department, {}),
          utils.extend(fields.installation_team, {}),
          utils.extend(fields.installation_base, {}),
          utils.extend(fields.floor, {}),
          utils.extend(fields.user_name, {}),
          utils.extend(fields.management_person_name, {})

        ],
        col2b:[
          utils.extend(fields.remarks, {}),
          utils.extend(fields.retraction_reason, {
            disabled : true,
            hide_all : true,
            force_write : false
          })
        ],
      }
    },
    loadBy(){
      return this.$route.meta.load_by;
    }
  },
  methods: {
    onDelete(){
      bus.$emit("deletedeviceEmbeddedInformationDetailModal",{
        title: "削除",
        message: "機器・組込情報の削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color:"danger",
        no_color:"info",
        model_height:"50"
      });
    },
    onConfirmDelete(mode){
      if(mode == "yes"){
        this.commonDelete(this);
      }
    },
    subTableSaved(cb){
      // if(this.$store.state[this.stateCurrentRow]["approval_status"] == "下書中"){
      //   console.log('TEST DEBUG 210606 (593 at page_0010_device_embedded_information_detail.vue)[00:41]: NO UPDATE THE MASTER', {  });
      //   return cb(null);
      // }
      this.onDeviceEmbeddedInformationAddCheckConfirm("yes",cb);
    },
    showHistory(){
      bus.$emit("showDeviceEmbeddedInformationlogHistoryModal",{
        fk_tab:constants.TABLE_ID.DEVICE_EMBEDDED_INFORMATION,
        fk_id:this.localSeqId,
      });
    },
    cloneRecord(){
      return this.$router.push({ name: "page_0060_redirect", params: {
        url:"/device_embedded_information/clone/" + this.localSeqId,
        message:"コピー ...",
        wait:50
      } });
    },
    processFieldStyle(store_key_name,last_changed_fields){
      if(Array.isArray(last_changed_fields)){
        last_changed_fields.forEach(e=>{
        })
      }else{
      }
      this.$store.state[store_key_name] = {};
      if(last_changed_fields && last_changed_fields != null && last_changed_fields.length > 0 ){
        last_changed_fields.forEach(f=>{
          if(this.showFieldchangedStyle){
            this.$store.state[store_key_name][f] = ";color:red;"
          }
        });
      }
    },
    processApproval(approve_mode){
      var changes = {
        seq_id:this.approvalId,
        update_time: moment(new Date()).format("YYYY/MM/DD HH:mm:ss")
      }

      if(approve_mode == "cancel"){
        this.commonSaveInfo(this,this.api_name, {from_edit_form: true},(err)=>{
          if(err){
            //commonSaveInfo already show the error, can ignore it
          }else{
            this.$ajax.post('/approval_history/prepare_to_approve/' + this.approvalId, {changes,approve_mode:approve_mode}, (err, result) => {
              if(err){
                this.$notify({
                  title: 'データの承認に失敗しました。',
                  text: err,
                  type: 'error',
                  duration: 10000
                });
              }else{
                bus.$emit("notificationAfterdeviceInformationApprovalStartedRequest",{
                  message: "自動でメール通知はされませんので、口頭または<br>メールで差戻したことを申請者へお伝えください。",
                  title: "申請が差戻されました",
                  yes_label: "",
                  no_label: "OK",
                  yes_color:"",
                  no_color:"",
                  model_height:"50",
                  model_width: "390px"
                });
              }
            });
          }
        });
      }else{
        var selected_approval_history = this.loadSelectedApprovalHistory()
        if(selected_approval_history.indexOf(this.approvalId) < 0){
          selected_approval_history.push(this.approvalId)
          Vue.localStorage.set('selected_approval_history',JSON.stringify(selected_approval_history))
        }
        bus.$emit("notificationAfterdeviceInformationApprovalStartedRequest", {
          message: "",
          title: "申請を確認しました。",
          yes_label: "",
          no_label: "OK",
          yes_color: "",
          no_color: "",
          model_height: "50",
        });
      }
    },
    processApprovalReason(approve_mode){
      var changes = {
        seq_id:this.approvalId,
        update_time: moment(new Date()).format("YYYY/MM/DD HH:mm:ss")
      }

      if(approve_mode == "cancel"){
        this.commonSaveInfo(this,this.api_name, {from_edit_form: true},(err)=>{
          if(err){
            //commonSaveInfo already show the error, can ignore it
          }else{
            this.$ajax.post('/approval_history/prepare_to_approve/' + this.approvalId, {changes,approve_mode:approve_mode}, (err, result) => {
              if(err){
                this.$notify({
                  title: 'データの承認に失敗しました。',
                  text: err,
                  type: 'error',
                  duration: 10000
                });
              }else{
                bus.$emit("notificationAfterdeviceInformationApprovalStartedRequest",{
                  message: "申請が取戻されました",
                  title: "",
                  yes_label: "",
                  no_label: "OK",
                  yes_color:"",
                  no_color:"",
                  model_height:"50",
                  model_width: "390px"
                });
              }
            });
          }
        });
      }else{
        var selected_approval_history = this.loadSelectedApprovalHistory()
        if(selected_approval_history.indexOf(this.approvalId) < 0){
          selected_approval_history.push(this.approvalId)
          Vue.localStorage.set('selected_approval_history',JSON.stringify(selected_approval_history))
        }
        bus.$emit("notificationAfterdeviceInformationApprovalStartedRequest", {
          message: "",
          title: "申請を確認しました。",
          yes_label: "",
          no_label: "OK",
          yes_color: "",
          no_color: "",
          model_height: "50",
        });
      }
    },
    processApprovalApprove(){
      return this.processApproval('approve');
    },
    processApprovalCancelBack(mode){
      if(mode == "yes"){
      console.log("processApprovalCancelBack",mode) 
      　this.processApproval('cancel');
        this.local_status = false;
        this.ApprovalCancelModeSet(false);
      }
    },
    processApprovalCancelBackReason(mode){
      if(mode == "yes"){
      console.log("processApprovalCancelBack",mode) 
      　this.processApprovalReason('cancel');
        this.local_status = false;
        this.ApprovalCancelModeSet(false);
      }
    },
    onDeviceEmbeddedInformationAddCheckConfirm(mode, cb=false){
      if(mode == "yes"){
        console.log("onDeviceEmbeddedInformationAddCheckConfirm",mode)
        this.read_only = false;
        this.$store.state[this.stateCurrentEditing]["approval_status"] = "下書中";
        this.commonSaveInfo(this,this.api_name, {from_edit_form: true },(err,data)=>{
          if(err){
            //commonSaveInfo alrady show the error, can ignore it
            if(cb){
              cb(err);
            }
          }else{
              bus.$emit("reloadSubTableDeviceEmbeddedInformation",{clear_list:true});
            if(this.is_new == true){
              this.saveEditClicked = true;
              bus.$emit("reloadSubTableDeviceEmbeddedInformation",{fk_id:this.deviceSeqId});
              this.localSeqId = this.deviceSeqId;
            }
            if(cb){
              return cb(null);
            }
            bus.$emit("notificationAfterSave",{
              message: "",
              title: "登録情報を下書保存しました。",
              yes_label: "",
              no_label: "OK",
              yes_color:"",
              no_color:"",
              model_height:"50"
            });
          }
        });
      }
    },
    onDeviceEmbeddedInformationUpAddCheckConfirm(mode){
      if(mode == "yes"){
        this.read_only = false;
        this.commonSaveInfo(this,this.api_name, {from_edit_form: true ,overwrite_changed_fields : true, approval_id:this.approvalId },(err)=>{
          if(err){
            //commonSaveInfo already show the error, can ignore it
          }else{
            bus.$emit("notificationAfterSave",{
              message: "",
              title: "登録情報を上書保存しました。",
              yes_label: "",
              no_label: "OK",
              yes_color:"",
              no_color:"",
              model_height:"50"
            });
          }
        });
      }
    },
    afterTheNotificationAfterSave(mode){
      if (mode == "no" || mode == "yes") {
        if(this.loadBy == "clone"){
          return this.$router.push({name:"page_0092_reload",params:{return_to:"/device_embedded_information/" + this.localSeqId}})
        }else{
          if(this.loadBy != "fk_id"){
            return this.$router.push("/device_embedded_information/" + this.localSeqId);
          }
        }
      }
    },
    afterTheNotificationAftercancel(mode){
      setTimeout(()=>{
        return this.$router.push("/approval_history");
      },600)
      console.log("afterTheNotificationAftercancel");
    },
    onConfirmExecuteProcess(){
      var dcn = this.deviceControlNumber;
      if(typeof dcn == undefined || dcn == null || dcn == false || dcn.length == 0){
        dcn  = "BY_SEQ_ID::" + this.localSeqId;
      }
      bus.$emit("deviceEmbeddedApplicationConfimationModal",{
        application_mode:"device_embedded",
        ref_id:dcn,
        // approval_status:this.approvalStatus,
        seq_id:this.localSeqId,
        load_previous_if_exist:true,
        approval_history_id : this.approvalHistoryId || false,
        approval_history_toroku_number : this.approvalHistoryTorokuNumber || false
      });
    },
    onConfirmExecuteProcessConfirmation(){
      var dcn = this.deviceControlNumber;
      if(typeof dcn == undefined || dcn == null || dcn == false || dcn.length == 0){
        dcn  = "BY_SEQ_ID::" + this.localSeqId;
      }
      bus.$emit("deviceEmbeddedApplicationConfimationModal",{
        application_mode:"device_embedded",
        ref_id:dcn,
        modal_is_read_only:true,
        seq_id:this.localSeqId,
        approval_history_id : this.approvalHistoryId || false,
        approval_history_toroku_number : this.approvalHistoryTorokuNumber || false
      });
    },
    hideApprovalCancelSet(flag){
      if (typeof this.fieldList["retraction_reason"] != "undefined"){
        // this.fieldList["retraction_reason"].hide_all = flag;
        if (typeof this.fieldList["retraction_reason"].ref_field != "undefined"){
          this.fieldList["retraction_reason"].ref_field.refresh_hide_force();
        }
      }
    },
    ApprovalCancelModeSet(aflag){
      var bflag = this.hideApprovalcancel;
      if (typeof this.fieldList["retraction_reason"] != "undefined"){
        if(aflag == true){
            // this.fieldList["retraction_reason"].hide_all = false;
            this.fieldList["retraction_reason"].force_write = true;
            this.approvalcancelmode = true;
        }else{
            // this.fieldList["retraction_reason"].hide_all = true;
            this.fieldList["retraction_reason"].force_write = false;
            this.approvalcancelmode = false;
        }
        if (typeof this.fieldList["retraction_reason"].ref_field != "undefined"){
        this.fieldList["retraction_reason"].ref_field.refresh_hide_force();
        }
      }
    },
    processApprovalCancel(){
      console.log("processApprovalCancel");
      this.ApprovalCancelModeSet(true);
    },
    onapprovalSaveDevEmbedded(){
     bus.$emit("confirmDeviceEmbeddedInformationAddcancel",{
        message: "よろしいですか？",
        title: "申請を差戻します。",
        yes_label: "差戻",
        no_label: "戻る",
        yes_color:"primary",
        no_color:"",
        model_height:"50"
      });
    },
    onapprovalSaveDevEmbeddedReason(){
     bus.$emit("confirmDeviceEmbeddedInformationAddcancelReason",{
        message: "よろしいですか？",
        title: "申請を取戻します。",
        yes_label: "取戻",
        no_label: "戻る",
        yes_color:"primary",
        no_color:"",
        model_height:"50"
      });
    },
    approvalCancelbtn(){
      this.ApprovalCancelModeSet(false);
    },
    onLocalSaveDevEmbedded(){
      var message = "よろしいですか？<br><span style='float: left;font-weight: 800;color:red;'>承認状態が【下書中】となるので、申請が必要になります。</span>";
      //if(this.is_new == true){
        if(this.showapprovalStatus == true) {
        message = "よろしいですか？<br><span style='float: left;font-weight: 800;color:red;'>※承認状態が【承認済】のものは【下書中】になります。 </span>";
      }
      this.commonValidateFields(this,{},(error_found)=>{
        if(error_found != false){
          return;
        }
        if(this.is_new == false){
          this.saveEditClicked = true;
        }
        console.log("onLocalSave")
        bus.$emit("confirmDeviceEmbeddedInformationAddCheck",{
          message:  message,
          title: "登録情報を下書保存します。",
          yes_label: "下書保存",
          no_label: "戻る",
          yes_color:"primary",
          no_color:"",
          model_height:"100",
          model_width: "450px"
        });
      });
    },
    onLocalUpSaveDevEmbedded(){
      console.log("onLocalSave")
      this.commonValidateFields(this,{},(error_found)=>{
        if(error_found != false){
          return;
        }
        bus.$emit("confirmDeviceEmbeddedInformationUpAddCheck",{
          message: "よろしいですか？",
          title: "登録情報を上書保存します。",
          yes_label: "上書保存",
          no_label: "戻る",
          yes_color:"primary",
          no_color:"",
          model_height:"50"
        });
      })
    },
    onEdit(){
      mdebug("on Edit")
      this.startCompanySelection();
      this.commonOnEdit();
      if (this.loadBy == "fk_id" && this.approvalStatus == "申請中") {
        this.fieldList["retraction_reason"].ref_field.$props.data.disabled  = false;
        this.fieldList["retraction_reason"].ref_field.localRefreshSequecnce++;
      }else{
        this.fieldList["retraction_reason"].ref_field.$props.data.disabled  = true;
        this.fieldList["retraction_reason"].ref_field.localRefreshSequecnce++;
      }
    },
    btnCancel() {
      this.commonValidateFieldsClear(this,()=>{})
      this.cancelCurrentSelection(true);
      this.local_status = false;
      this.$store.state[this.stateCurrentEditing]["approval_status"] =""
      this.$store.state[this.stateCurrentRow]["approval_status"] =""
      this.loadFormData();
    },
    backToList(){
      var device_back_to_list = window.sessionStorage.getItem("device_back_to_list")
      if(this.loadBy == "clone"){
        return this.$router.push({ name: "page_0010_device_embedded_information", params: {} });
      }else  if((device_back_to_list||"").indexOf("/")==0){
        return this.$router.push(device_back_to_list);
      }
    },
    gotocertificate(){
      return this.$router.push({ name: "page_0040_certificate_information", params: {} });
    },
    selectCertificate(){
      this.showSubTable = true;
    },
    confirmedSetdevice(mode){
      if(mode == "yes"){
        bus.$emit("device_number_force_update",this.temp_device_management_number );
      }else if(mode == "no"){
          return bus.$emit("showdeviceModal");
      }
    },
    devicePopUp(){
      bus.$emit("showdeviceModal");
    },
    ondeviceModalSelected(val){
      if(val && val.length > 0){
          bus.$emit("showConfimationModalSetdevice", {
                title:"",
                message:"管理番号 '"+val+"' を割り当てます。よろしいですか？",
                yes_label:"OK",
                no_label:"戻る",
                yes_color:"primary",
                model_height:80
              })
        this.temp_device_management_number = val;
      }
    },
    prepareCompanySelection(companies, department_and_team, company_field, department_field,team_field,company_field_name,department_field_name){
      var selected_company = false;
      var selected_department = false
      company_field.page_controller_setup({
        on_select:(_selected_company)=>{
          selected_company = _selected_company;
          if(selected_company==""){
            department_field.page_controller_msg({cmd:"disable"})
            team_field.page_controller_msg({cmd:"disable"})
          }else{
            var departments =  _.uniq(_.map(_.filter(department_and_team||[],(d)=>{return d.company == selected_company})||[],"department")||[]);
            departments.unshift("")
            department_field.page_controller_msg({cmd:"enable"})
            department_field.page_controller_msg({cmd:"set_value",val:""})
            team_field.page_controller_msg({cmd:"set_value",val:""})
            team_field.page_controller_msg({cmd:"disable"})
            department_field.page_controller_msg({cmd:"set_options",options:departments, reset:true})
          }
        }
      })
      department_field.page_controller_setup({
        on_select:(_selected_department)=>{
          selected_department = _selected_department;
          if(selected_department == ""){
            team_field.page_controller_msg({cmd:"disable"})
            team_field.page_controller_msg({cmd:"set_value",val:""})
          }else{
            var teams =  _.uniq(_.map(_.filter(department_and_team||[],(d)=>{return d.company == selected_company && d.department == selected_department})||[],"team")||[]);
            teams.unshift("");
            team_field.page_controller_msg({cmd:"enable"})
            team_field.page_controller_msg({cmd:"set_value",val:""})
            team_field.page_controller_msg({cmd:"set_options",options:teams, reset:true})
          }
        }
      })
      company_field.page_controller_msg({cmd:"set_options",options: _.clone(companies)})
      company_field.page_controller_msg({cmd:"enable"})
      department_field.page_controller_msg({cmd:"disable"})
      team_field.page_controller_msg({cmd:"disable"})
      setTimeout(() => {
        department_field.page_controller_msg({cmd:"enable_if_data"})
        team_field.page_controller_msg({cmd:"enable_if_data"})
        selected_company = this.$store.state[this.stateCurrentRow][company_field.id]
        selected_department = this.$store.state[this.stateCurrentRow][department_field.id]
        if(selected_company && selected_company.length > 0){
          department_field.page_controller_msg({ cmd: "enable" });
          var departments =  _.uniq(_.map(_.filter(department_and_team||[],(d)=>{return d.company == selected_company})||[],"department")||[]);
          department_field.page_controller_msg({cmd:"set_options",options:departments, reset:false})
          if(selected_department && selected_department.length > 0){
            var teams =  _.uniq(_.map(_.filter(department_and_team||[],(d)=>{return d.company == selected_company &&  d.department == selected_department})||[],"team")||[]);
            team_field.page_controller_msg({cmd:"set_options",options:teams, reset:false})
          }
        }
      }, (this.is_new)?100:500);
    },
    startCompanySelection(){
      if(this.company_selection_started == true){
        return;
      }
      this.company_selection_started  = true;
      if(true){
        var temp_fields = this.installedFieldList;
        // Load the companies
        this.$ajax.post_cached_queued('/master_company/list_company_name' , {}, (err, _companies) => {
          if(err){
            this.$notify({
                title: '所管会社のデータが読込めませんでした。',
                text: err,
                type: 'error',
                duration: 10000
              });
            return ;
          }
          var companies = [""]
          _companies.forEach(c=>{
            companies.push(c.val)
          })
          // Load the departments and teams
          this.$ajax.post_cached_queued('/master_belongs/list_team_and_department' , {}, (err, department_and_team) => {
            if(err){
              this.$notify({
                  title: '部署・チームのデータの読込に失敗しました。',
                  text: err,
                  type: 'error',
                  duration: 10000
                });
              return ;
            }
            this.prepareCompanySelection(_.clone(companies), _.clone(department_and_team), temp_fields.company, temp_fields.equipment_in_charge_department,temp_fields.equipment_in_charge_team,"company","department")
            if(this.$route.params.seq_id == "new"){
              var default_company = Vue.localStorage.get(temp_fields.company.default_from_local_storage);
              if(default_company != constants.COMPANY.ALL){
                setTimeout(() => {
                  var default_deparment = Vue.localStorage.get(temp_fields.equipment_in_charge_department.default_from_local_storage);
                var default_team = Vue.localStorage.get(temp_fields.equipment_in_charge_team.default_from_local_storage);
                temp_fields.company.page_controller_msg({cmd:"set_value",val:default_company})
                temp_fields.equipment_in_charge_department.page_controller_msg({cmd:"set_value",val:default_deparment})
                temp_fields.equipment_in_charge_team.page_controller_msg({cmd:"set_value",val:default_team})
                }, (this.is_new)?300:1000);
              }
            }
          })
        })
      }
    },
    loadFormData(){
      console.log("Load DeviceEmbeddedInformation",this.loadBy)
      this.approvalHistoryBulkTorokuNumberQty = 0;
      this.fieldList["retraction_reason"].hide_all = true;
      if(this.loadBy == "fk_id"){
          this.is_new = false;
          this.localSeqId = this.$route.params.fk_id;
          this.approvalId = this.$route.params.approval_id;
          this.$ajax.post('/' + this.api_name + '/get/' + this.$route.params.fk_id, {fk_id: this.$route.params.fk_id}, (err, result) => {
            if(err){
              this.$notify({
                title: 'データの読込に失敗しました。',
                text: err,
                type: 'error',
                duration: 10000
              });
            }
            this.localSeqId = result.data.seq_id;
            this.$store.state[this.stateCurrentRow] = result.data;
            this.fieldList["retraction_reason"].hide_all = this.$store.state[this.stateCurrentRow].approval_status == "承認済";
            this.refreshSequencer++;
            if(typeof this.$store.state[this.stateCurrentRow].approval_history_id == "number" &&
              isNaN(this.$store.state[this.stateCurrentRow].approval_history_toroku_number) == false
            ){
              this.approvalHistoryId = this.$store.state[this.stateCurrentRow].approval_history_id;
              if(this.approvalHistoryId > 0){
                this.approvalId = this.approvalHistoryId
              }
              this.approvalHistoryTorokuNumber = this.$store.state[this.stateCurrentRow].approval_history_toroku_number
              if(this.approvalHistoryId == -200){
                this.approvalHistoryTorokuNumber
              }
            }
            this.approvalHistoryBulkTorokuNumberQty = result.data.approval_history_bulk_toroku_number_qty || 0;
            this.commonSetStyleForChangedFields(result.data);
            bus.$emit("reloadSubTableDeviceEmbeddedInformation",{fk_id:this.localSeqId});
            mdebug("LOAD DATA",{err, result});
          })
      }else if(this.loadBy == "clone"){
          this.startCompanySelection();
          this.is_new = true;
          this.localSeqId = Number.MAX_SAFE_INTEGER
          this.$ajax.post('/' + this.api_name + '/get/' + this.$route.params.seq_id, {}, (err, result) => {
            if(err){
              this.$notify({
                title: 'データの読込に失敗しました。',
                text: err,
                type: 'error',
                duration: 10000
              });
            }
            // result.data.seq_id = Number.MAX_SAFE_INTEGER;
            // result.data.device_control_number = "";
            this.$store.state[this.stateCurrentRow] = {};
            this.$store.state[this.stateCurrentEditing] = {};
            Object.keys(result.data).forEach(k =>{
              var value = result.data[k];
              if(k == "seq_id"){
                this.$store.state[this.stateCurrentRow][k] = Number.MAX_SAFE_INTEGER;
                // this.$store.state[this.stateCurrentEditing][k] = Number.MAX_SAFE_INTEGER;
              }else if(k == "device_control_number"){
                this.$store.state[this.stateCurrentRow][k] = "";
                this.$store.state[this.stateCurrentEditing][k] = "";
              }else if(k == "approval_status_flag"){
                this.$store.state[this.stateCurrentRow][k] = 0;
                this.$store.state[this.stateCurrentEditing][k] = 0;
              }else if(k == "approval_status"){
                this.$store.state[this.stateCurrentRow][k] = "";
                this.$store.state[this.stateCurrentEditing][k] = "";
              }else{
                this.$store.state[this.stateCurrentRow][k] = value;
                this.$store.state[this.stateCurrentEditing][k] = value;
              }

            })
            this.Status = "使用中";
            this.commonSetStyleForChangedFields(result.data);
            this.refreshSequencer++;
            setTimeout(() => {
              this.$store.state[this.stateIsEditingNew] = true;
              this.read_only = false;
              this.is_new = true;
            }, 300);
            this.commonEditDeleteCmdHandler(this);

          })
      }else{
        setTimeout(()=>{
            this.localSeqId = this.$route.params.seq_id;
            console.log("Load DeviceEmbeddedInformation else 2",this.localSeqId)
            bus.$emit("reloadSubTableDeviceEmbeddedInformation",{fk_id:this.localSeqId});
          },2)

        this.commonLoadRecord({},(err,result)=>{
          console.log("Load DeviceEmbeddedInformation else",this.localSeqId)
          if(this.$route.params.seq_id == "new"){
              this.Cpu_Count = "1";
              this.Status = "使用中";
              setTimeout(() => {
                this.startCompanySelection();
              }, 10);
          }
            if(typeof this.$store.state[this.stateCurrentRow].approval_history_id == "number" &&
            isNaN(this.$store.state[this.stateCurrentRow].approval_history_toroku_number) == false
            ){
              this.approvalHistoryId = this.$store.state[this.stateCurrentRow].approval_history_id
              this.approvalHistoryTorokuNumber = this.$store.state[this.stateCurrentRow].approval_history_toroku_number
              if(this.approvalHistoryId == -200){
                this.approvalHistoryTorokuNumber
              }
            }
          this.commonEditDeleteCmdHandler(this);
          this.refreshSequencer++;
        })
      }
    }

  },
  mounted() {
    this.loadFormData();

  },
  beforeDestroy() {
    this.approvalHistoryBulkTorokuNumberQty = 0;
    mdebug("LOCAL beforeDestroy ")
    var store_style = this.$store.state[this.stateCurrentRow.replace("current_row","current_field_style")] = {};
  },
  beforeMount() {
  },

  }


</script>
<style scoped>

.bottom_tab  {
  width: 100%;
  margin-bottom: 20px;
}
.bottom_tab th {
  font-size: 12px;
}
.bottom_tab td input{
  border: solid #337ab7 1px;
  width: 98%;
  margin: 2px;
  border-radius: 5px;
  background-color: #e2ecf5;
  font-size: 12px;
  padding-left:4px;
}
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
.fade-enter {
  /*開始の状態を指定する*/
  opacity: 1;
  transform: translateY(-20px);
}
.fade-enter-to {
  /*終了の状態を指定する*/
  opacity: 1;
}
.fade-enter-active {
  /*動作（イージングや時間）を指定する*/
  transition: opacity 300ms ease-out, transform 300ms ease-out;
}
.fade-leave {
  opacity: 1;
}
.fade-leave-to {
  opacity: 1;
  transform: scale(0.97);
}
.fade-leave-active {
  transition: opacity 270ms ease-out, transform 270ms ease-out;
}
</style>



// WEBPACK FOOTER //
// page_0010_device_embedded_information_detail.vue?a9d50362